<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <h1>
                        Login
                    </h1>

                    <b-form @submit.prevent="onSubmit()">
                        <b-form-group>
                            <label>
                                Email Address
                            </label>

                            <b-form-input
                                v-model="form.email"
                                type="email"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-form-group>
                            <label>
                                Password
                            </label>

                            <b-form-input
                                v-model="form.password"
                                type="password"
                                required>
                            </b-form-input>
                        </b-form-group>

                        <b-button type="submit" variant="primary">
                            Login
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    email: "",
                    password: ""
                }
            }
        },

        methods: {
            onSubmit() {

            }
        }
    }
</script>

<style scoped>

</style>